import { cn } from '@/lib/utils';

const ReleasePanelLayout = ({ className, leftPanel, rightPanel }) => {
  return (
    <div className={cn('flex border rounded-md h-[calc(100vh-220px)]', className)}>
      <div className="w-1/4 border-r overflow-y-auto p-4">
        {leftPanel}
      </div>
      <div className="w-3/4 overflow-y-auto p-6">
        {rightPanel}
      </div>
    </div>
  );
};

export default ReleasePanelLayout;
